export class ExpandedNodesHelper<TNode>
{
    private expandedIds: Set<string>;
    private parentIdByNodeId: Map<string, string | null>;

    constructor(nodes: TNode[], getNodeId: (node: TNode) => string, getParentNodeId: (node: TNode) => string | null, expandedIds: string[])
    {
        this.expandedIds = new Set(expandedIds);
        this.parentIdByNodeId = new Map<string, string | null>();
        
        for (const node of nodes)
        {
            this.parentIdByNodeId.set(getNodeId(node), getParentNodeId(node));
        }
    }

    public areAllAncestorsExpanded(nodeId: string): boolean
    {
        const visitedIds = new Set<string>();
        let parentId = this.parentIdByNodeId.get(nodeId) ?? null;

        while (parentId != null)
        {
            if (!this.expandedIds.has(parentId))
            {
                return false;
            }
            else if (visitedIds.has(parentId))
            {
                break; // guard against a malformed cyclic parent chain
            }
            else
            {
                visitedIds.add(parentId);
                parentId = this.parentIdByNodeId.get(parentId) ?? null;
            }
        }
        return true;
    }
}
